import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    opacity: 0;\n    margin: 0;\n    width: 0;\n    height: 0;\n    pointer-events: none;\n    position: absolute;\n\n    &:checked + ", " {\n        ", "\n    }\n\n    &:checked + ", ":hover {\n        ", "\n    }\n\n    &:checked + ", ":after {\n        left: calc(100% - 2px);\n        transform: translateX(-100%);\n    }\n\n    &:disabled + ", " {\n        ", "\n    }\n\n    &:disabled:checked + ", " {\n        ", "\n    }\n\n    &:disabled + ", ":after {\n        ", "\n    }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    position: relative;\n    display: inline-flex;\n    border-radius: 9999px;\n    transition: all ", "s ease;\n    width: ", "px;\n    height: ", "px;\n\n    &::after {\n        content: '';\n        position: absolute;\n        bottom: ", "px;\n        left: ", "px;\n        width: ", "px;\n        height: ", "px;\n        border-radius: 9999px;\n        transition: all ", "s ease;\n\n        ", "\n    }\n\n    ", "\n    ", "\n    ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    display: inline-flex;\n    align-items: center;\n\n    ", ";\n    ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { getPropsBlocker } from '../../utils';
import { mouseCursor, pointerEvents } from '../../styling';
import { transitionDurationInSec } from '../../constants';
import { getComponentOverride } from '../../system/mixins/getComponentOverride';
var sizes = {
  dimensions: {
    width: 32,
    height: 18,
    padding: 2
  },
  toggle: {
    side: 14
  }
};

var switchColor = function switchColor(_ref) {
  var Switch = _ref.theme.componentOverrides.Switch;
  return Switch.Label.base;
};

var toggleDefault = function toggleDefault(_ref2) {
  var Switch = _ref2.theme.componentOverrides.Switch;
  return Switch.Toggle.base;
};

var disabledToggle = function disabledToggle(_ref3) {
  var Switch = _ref3.theme.componentOverrides.Switch,
      checked = _ref3.checked,
      defaultChecked = _ref3.defaultChecked;
  return !(checked || defaultChecked) ? Switch.Toggle.disabled__checked : '';
};

var checkedBackground = function checkedBackground(_ref4) {
  var Switch = _ref4.theme.componentOverrides.Switch;
  return Switch.Label.checked;
};

var checkedHover = function checkedHover(_ref5) {
  var Switch = _ref5.theme.componentOverrides.Switch;
  return Switch.Label.hover;
};

var disabledBackground = function disabledBackground(_ref6) {
  var Switch = _ref6.theme.componentOverrides.Switch;
  return Switch.Label.disabled;
};

var disabledCheckedBackground = function disabledCheckedBackground(_ref7) {
  var Switch = _ref7.theme.componentOverrides.Switch;
  return Switch.Label.disabled__checked;
};

export var SwitchRoot = styled.label.withConfig(getPropsBlocker())(_templateObject(), getComponentOverride('Switch'), mouseCursor);
export var SwitchToggle = styled.span.withConfig(getPropsBlocker())(_templateObject2(), transitionDurationInSec, sizes.dimensions.width, sizes.dimensions.height, sizes.dimensions.padding, sizes.dimensions.padding, sizes.toggle.side, sizes.toggle.side, transitionDurationInSec, toggleDefault, pointerEvents, switchColor, mouseCursor);
export var SwitchCheckboxInput = styled.input.withConfig(getPropsBlocker())(_templateObject3(), SwitchToggle, checkedBackground, SwitchToggle, checkedHover, SwitchToggle, SwitchToggle, disabledBackground, SwitchToggle, disabledCheckedBackground, SwitchToggle, disabledToggle);